import React, { useContext, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import DashboardPreview from '../components/DashboardPreview';

const Landing = () => {

  const {currentUser, loading} = useContext(AuthContext);

  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && currentUser) {
      navigate('/app/dashboard');
    }
  }, [currentUser, navigate]);



  return (
    <div className="min-h-screen bg-white">
      {/* Announcement Banner */}
      <div className="bg-yellow-100 px-4 py-2 text-center">
        🎉 Nuevo Lanzamiento <span className="font-medium">WhatsApp AI</span> — una nueva forma de automatizar tus conversaciones con clientes <a href="#" className="text-primary-600 hover:text-primary-700 font-medium">Conoce más</a>
      </div>

      {/* Navigation */}
      <nav className="px-6 py-4 lg:px-8">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center">
            <Link to="/" className="text-2xl font-bold text-primary-600">Fivia</Link>
            <div className="hidden md:flex items-center ml-10 space-x-8">
              <Link to="/features" className="text-gray-600 hover:text-gray-900">Características</Link>
              <Link to="/ai-flows" className="text-gray-600 hover:text-gray-900">Flujos IA</Link>
              <Link to="/whatsapp" className="text-gray-600 hover:text-gray-900">WhatsApp IA</Link>
              <Link to="/about" className="text-gray-600 hover:text-gray-900">Nosotros</Link>
              <Link to="/resources" className="text-gray-600 hover:text-gray-900">Recursos</Link>
            </div>
          </div>
          <div className="flex items-center space-x-4">
            <Link to="/app/login" className="text-gray-600 hover:text-gray-900">Iniciar Sesión</Link>
            <Link to="/app/dashboard" className="bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700 transition-colors">
              Solicitar Demo
            </Link>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <main className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold text-gray-900 mb-6 leading-tight">
            Fivia es la plataforma para optimizar todo tu negocio.
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-10">
            Conoce el sistema para modernizar tu empresa. Automatiza tus cotizaciones, pagos y ventas.
          </p>
          <div className="flex justify-center gap-4">
            <Link
              to="/demo"
              className="bg-black text-white px-6 py-3 rounded-lg hover:bg-gray-800 transition-colors"
            >
              Comienza ahora
            </Link>
            <button
              className="border border-gray-300 px-6 py-3 rounded-lg hover:bg-gray-50 transition-colors inline-flex items-center"
            >
              <span className="mr-2">▶</span> Ver Demo (3 min)
            </button>
          </div>
        </div>

        {/* Stats/Features Preview */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto text-center">
          <div className="p-6 rounded-xl bg-gray-50">
            <div className="text-4xl font-bold text-primary-600 mb-2">95%</div>
            <p className="text-gray-600">Reducción en tiempo de respuesta</p>
          </div>
          <div className="p-6 rounded-xl bg-gray-50">
            <div className="text-4xl font-bold text-primary-600 mb-2">24/7</div>
            <p className="text-gray-600">Atención al cliente automatizada</p>
          </div>
          <div className="p-6 rounded-xl bg-gray-50">
            <div className="text-4xl font-bold text-primary-600 mb-2">50K+</div>
            <p className="text-gray-600">Mensajes automatizados por mes</p>
          </div>
        </div>

        {/* Dashboard Preview with Gradient Effect */}
        <div className="mt-20 relative">
          {/* Gradient overlays */}
          <div className="absolute inset-0 bg-gradient-to-b from-white via-transparent to-white z-10 pointer-events-none"></div>
          <div className="absolute -left-1/4 top-1/4 w-1/2 h-1/2 bg-primary-200 rounded-full filter blur-3xl opacity-20 animate-blob"></div>
          <div className="absolute -right-1/4 top-1/4 w-1/2 h-1/2 bg-blue-200 rounded-full filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>
          <div className="absolute left-1/4 bottom-1/4 w-1/2 h-1/2 bg-yellow-200 rounded-full filter blur-3xl opacity-20 animate-blob animation-delay-4000"></div>
          
          {/* Dashboard Preview */}
          <div className="relative z-0 transform hover:scale-[1.02] transition-transform duration-500">
            <DashboardPreview />
          </div>
        </div>
      </main>
    </div>
  );
};

export default Landing; 